import { __awaiter } from 'tslib';

const REQUIRED = 'REQUIRED';
const INVALID_DATE = 'INVALID_DATE';
const INVALID_YEAR = 'INVALID_YEAR';
const INVALID_FORMAT = 'INVALID_FORMAT';
const MIN = 'MIN';
const MAX = 'MAX';
const INCOMPLETE = 'INCOMPLETE';
const CHECKBOX = 'CHECKBOX';
const RADIO = 'RADIO';
const MINLENGTH = 'MINLENGTH';
const MAXLENGTH = 'MAXLENGTH';
const SUCCESS = 'SUCCESS';
const INVALID_CRED = 'INVALID_CRED';
const INVALID_EMAIL = 'INVALID_EMAIL';
const CONFIRM_PASSWORD = 'CONFIRM_PASSWORD';
const INVALID_NUMBER = 'INVALID_NUMBER';
const INVALID_NUMBER_2 = 'INVALID_NUMBER_2';
const ALPHABETS_ONLY = 'ALPHABETS_ONLY';
const ZIPCODE_ONLY = 'ZIPCODE_ONLY';
const NUMBERS_ONLY = 'NUMBERS_ONLY';
const NUMBER_ONLY = 'NUMBER_ONLY';
const WAGES_TO_GREATER = 'WAGES_TO_GREATER';
const defaultErrorMessages = new Map([
    [REQUIRED, 'This field is required.'],
    [INVALID_DATE, 'Please enter a valid date.'],
    [INVALID_FORMAT, 'Please enter in the correct format.'],
    [MIN, 'Please enter a value of at least.'],
    [MAX, 'Please enter a value no greater than.'],
    [INCOMPLETE, 'Please complete all fields.'],
    [ZIPCODE_ONLY, 'Please enter a valid zipcode.'],
    [INVALID_YEAR, 'Please enter a valid year.'],
    [CHECKBOX, 'Please make at least one selection.'],
    [RADIO, 'Please make a selection.'],
    [MINLENGTH, 'Please enter at least.'],
    [MAXLENGTH, 'Please enter no greater than.'],
    [INVALID_CRED, 'Login credentials are incorrect. Please try again.'],
    [INVALID_EMAIL, 'Please enter a valid Email'],
    [CONFIRM_PASSWORD, 'Confirm password entered is not matching your password.'],
    [INVALID_NUMBER, 'Please enter a valid Number'],
    [WAGES_TO_GREATER, 'Wage to greater than or equal to wage from'],
    [NUMBER_ONLY, 'Please enter numbers only'],
    [INVALID_NUMBER_2, 'Invalid Number'],
    [NUMBERS_ONLY, 'Enter 3 digit number'],
    [ALPHABETS_ONLY, 'Please enter alphabets only'],
]);
let errorMessages = new Map(defaultErrorMessages);
const InvalidCredMessage = '';
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function groupBy(InputArray, property) {
    return InputArray.reduce(function (accumulator, object) {
        const key = object[property];
        if (!accumulator[key]) {
            accumulator[key] = [];
        }
        accumulator[key].push(object);
        return accumulator;
    }, {});
}
function fetchTranslations(http) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const currentLang = sessionStorage.getItem('currentLanguage') || 'en';
        if (currentLang === 'en') {
            errorMessages = new Map(defaultErrorMessages);
            return;
        }
        const storedTranslation = sessionStorage.getItem('transletedLabel');
        const existingTranslations = storedTranslation ? JSON.parse(storedTranslation) : [];
        const translatedSet = new Set(existingTranslations
            .filter(item => { var _a; return (_a = item.translatedNames) === null || _a === void 0 ? void 0 : _a[currentLang]; })
            .map(item => item.labelname));
        const missingLabels = Array.from(defaultErrorMessages.values())
            .filter(message => !translatedSet.has(message))
            .map(labelname => ({ labelname }));
        if (missingLabels.length === 0) {
            updateErrorMessages(existingTranslations, currentLang);
            return;
        }
        try {
            const response = yield http.post(`/translate/labels`, {
                fromLanguage: 'en',
                toLanguage: currentLang,
                labelList: missingLabels,
            }).toPromise();
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                const updatedLabels = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.labelList) || [];
                const updated = yield updateSessionStorage(updatedLabels, currentLang);
                updateErrorMessages(updated, currentLang);
            }
        }
        catch (error) {
            console.error('Translation API failed:', error);
        }
    });
}
function updateErrorMessages(translations, currentLang) {
    const newMap = new Map();
    const translationMap = new Map(translations.map(item => { var _a; return [item.labelname, (_a = item.translatedNames) === null || _a === void 0 ? void 0 : _a[currentLang]]; }));
    for (const [key, labelname] of defaultErrorMessages) {
        const translated = translationMap.get(labelname);
        newMap.set(key, translated || labelname);
    }
    errorMessages = newMap;
}
function updateSessionStorage(newTranslations, currentLang) {
    const storedTranslation = sessionStorage.getItem('transletedLabel');
    const existing = storedTranslation ? JSON.parse(storedTranslation) : [];
    newTranslations.forEach(newItem => {
        const existingIndex = existing.findIndex(res => res.labelname === newItem.labelname);
        if (existingIndex !== -1) {
            existing[existingIndex].translatedNames = Object.assign(Object.assign({}, (existing[existingIndex].translatedNames || {})), { [currentLang]: newItem.translatedName });
        }
        else {
            existing.push({
                labelname: newItem.labelname,
                translatedNames: {
                    [currentLang]: newItem.translatedName
                }
            });
        }
    });
    sessionStorage.setItem('transletedLabel', JSON.stringify(existing));
    return existing;
}

/*
 * Public API Surface of error-message-utility
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALPHABETS_ONLY, CHECKBOX, CONFIRM_PASSWORD, INCOMPLETE, INVALID_CRED, INVALID_DATE, INVALID_EMAIL, INVALID_FORMAT, INVALID_NUMBER, INVALID_NUMBER_2, INVALID_YEAR, InvalidCredMessage, MAX, MAXLENGTH, MIN, MINLENGTH, NUMBERS_ONLY, NUMBER_ONLY, RADIO, REQUIRED, SUCCESS, WAGES_TO_GREATER, ZIPCODE_ONLY, defaultErrorMessages, errorMessages, fetchTranslations, getCookie, groupBy };
//# sourceMappingURL=error-message-utility.js.map
